import * as mapboxgl from 'mapbox-gl';

// Esse arquivo contém funções úteis para trabalhar com o Mapbox GL
// e contornar problemas de tipo com TypeScript

export const setupMapboxGL = (token: string): void => {
  (mapboxgl as any).accessToken = token;
};

export const createMap = (container: string, options: any): any => {
  return new (mapboxgl as any).Map({
    container,
    ...options
  });
};

export const createNavigationControl = (): any => {
  return new (mapboxgl as any).NavigationControl();
};

export const createMarker = (element: HTMLElement): any => {
  return new (mapboxgl as any).Marker(element);
};

export const createPopup = (options?: any): any => {
  return new (mapboxgl as any).Popup(options);
};

export const createLngLatBounds = (): any => {
  return new (mapboxgl as any).LngLatBounds();
}; 